export default {
  landing: {
    title: "Nous trouvons gratuitement le meilleur prix pour votre chantier solaire !",
    titleBefore: "Nous trouvons gratuitement ",
    titleHighlight: "le meilleur prix",
    titleAfter: " pour votre chantier solaire !",
    shareQuote: "Partagez-nous le montant de votre devis. Avec 1200 artisans RGE de proximité sans sous-traitance, nous pourrions faire mieux.",
    getStarted: "Commencer",
    uploadInstead: "Déposer votre fichier devis à la place",
    stepLabel: "Étape",
    step1: "Nous définissons les spécifications",
    step2: "Vous recevez des offres contrôlées",
    step3: "Choisissez votre prix !",
    step4: "Démarche urbanisme à la mairie offerte",
  },
  header: "Get best price / Quote info",
  upload: {
    title: "Votre devis pour une installation photovoltaïque",
    automatic: "Automatique",
    manual: "Manuel",
    uploadLabel: "Téléversez votre fichier de devis",
    uploadHint: "PDF, JPEG, PNG. Jusqu'à 10 Mo.",
    next: "Suivant",
  },
  final: {
    thanks: "Merci, nous vous recontacterons bientôt !",
    wantToKnowMore: "Vous souhaitez en savoir plus sur nos activités ?",
    learnMoreDescription:
      "Nous sommes spécialisés dans l'optimisation de tous les aspects de l'écosystème des installations solaires afin d'en maximiser l'efficacité et la durabilité.",
    learnMore: "En savoir plus sur nous >",
  },
  projectType: {
    title: "Type de chantier",
    solarPanels: "Panneaux solaires",
    battery: "Batterie",
    evCharger: "Chargeur EV",
    heatPump: "Pompe à chaleur",
    next: "Suivant",
  },
  quoteAmount: {
    title: "Quel devis avez-vous obtenu pour l'installation ?",
    label: "Montant total pour les matériaux et l'installation",
    ht: "HT",
    ttc: "TTC",
    excludingTax: "Hors taxes, HT",
    includingTax: "Toutes taxes comprises, TTC",
    next: "Suivant",
  },
  timeline: {
    title: "Quand votre système sera-t-il installé ?",
    within1Month: "Dans un délai de 1 mois",
    within3Months: "Dans un délai de 3 mois",
    within6Months: "Dans un délai de 6 mois",
    moreThan6Months: "Plus de 6 mois après",
    hint: "Donnez une approximation si nécessaire.",
    next: "Suivant",
  },
  status: {
    title: "Étape suivante",
    description: "Aidez-nous à comprendre s'il n'est pas trop tard pour vous de bénéficier d'un meilleur prix.",
    installationDone: "Aucune, mon installation est déjà terminée",
    signedQuote: "Je veux un conseil, j'ai signé mon devis",
    wantBetterPrice: "Je veux un meilleur prix, je n'ai pas encore choisi de devis",
    noQuote: "Je souhaite trouver un artisan RGE près de chez moi, je n'ai pas de devis",
    next: "Suivant",
  },
  additionalInfo: {
    title: "Une dernière étape",
    label: "Toute information supplémentaire que nous devons connaître",
    placeholder: "Lorem ipsum",
    next: "Suivant",
  },
  contact: {
    title: "Vos coordonnées",
    intro: "Nous sommes un orchestrateur de chantiers solaires avec plus de 200 MW de sites alimentés en électricité.",
    learnMore: "En savoir plus sur nous",
    next: "Suivant",
  },
  gotQuestions: "Vous avez des questions ?",
  bookCall: "Réserver un appel",
}
